import React from 'react';
import { ImageBox } from '../basic/ImageBox';
import './CardRibbon.css'
import { tactin } from '../../utils/TactinGlobals';

type Props = {
    icon: string;
    headline: string;
}

export default function CardRibbon({ icon, headline }: Props) {
    const translatedHeadline = tactin().configuration.translate(headline);

    return (
        <ImageBox iconName={icon} label={translatedHeadline} className='card-ribbon' />
    );
}